// Page titles in the interface language (docs/plans/phase3-portal-feedback-kiswahili.md §8).
//
// Pages write their titles in English (`<PageHeader title="Reception" />`). The staff shell
// shows the title through this map, so the pages the navigation opens read in Kiswahili
// without changing every page file while other slices are editing them. A page that is
// translated properly later calls t() itself and its entry here can go.

import type { Translate } from './i18n.tsx';
import type { MessageKey } from './messages/en.ts';

export const PAGE_TITLE_KEYS: Readonly<Record<string, MessageKey>> = {
  Home: 'page.home',
  Reception: 'nav.reception',
  'Record merges': 'nav.recordMerges',
  Appointments: 'nav.appointments',
  Records: 'nav.records',
  Charts: 'nav.charts',
  Referrals: 'nav.referrals',
  'Deaths and births': 'nav.deathsAndBirths',
  Feedback: 'page.feedback',
  Casualty: 'nav.casualty',
  Queue: 'nav.queue',
  Lab: 'nav.lab',
  Imaging: 'nav.imaging',
  Wards: 'nav.wards',
  Theatre: 'nav.theatre',
  Maternity: 'nav.maternity',
  Mortuary: 'nav.mortuary',
  Pharmacy: 'nav.pharmacy',
  Stores: 'nav.stores',
  Procurement: 'nav.procurement',
  Cashier: 'nav.cashier',
  Approvals: 'nav.approvals',
  Claims: 'nav.claims',
  Insurance: 'nav.insurance',
  Reports: 'nav.reports',
  Staff: 'nav.staff',
  Settings: 'nav.settings',
  Account: 'page.account',
  'Patient portal': 'page.patientPortal',
  'Something went wrong': 'error.title',
  'Page not found': 'error.notFoundTitle',
};

/** The title in the interface language, or as written when there are no words for it yet. */
export function translatePageTitle(t: Translate, title: string): string {
  const key = Object.hasOwn(PAGE_TITLE_KEYS, title) ? PAGE_TITLE_KEYS[title] : undefined;
  if (key !== undefined) return t(key);
  const welcome = /^Welcome, (.+)$/.exec(title);
  if (welcome?.[1] !== undefined) return t('page.welcome', { name: welcome[1] });
  return title;
}
